module.exports = __webpack_public_path__ + "static/media/down.af11e040.svg";